export default __webpack_public_path__ + "static/media/gallery_03.92bc6398.jpg";